<template>
  <Modal
    v-if="loaded"
    ref="modal"
    title="Job Refresh Settings"
    action="Save"
    action-color="indigo"
    @close-modal="handleCancelSettings"
    @handle-action="updateTeam"
  >
    <div class="space-y-4">
      <div>
        <div class="flex items-center justify-between">
          <div>
            <label class="block text-sm font-medium text-gray-700">Refresh Strategy</label>
            <p class="text-sm text-gray-500">
              Leverage AI to refresh my job descriptions. You will no longer have to manually update job descriptions
              that go stale.
            </p>
          </div>
          <ToggleInput :model-value="team.useAiForJobRefresh" @update:model-value="team.useAiForJobRefresh = $event" />
        </div>
      </div>

      <div v-if="team.useAiForJobRefresh" class="mt-6">
        <label class="block text-sm font-medium text-gray-700">Review Strategy</label>
        <p class="text-sm text-gray-500 mb-2">How do you want job refreshes to be reviewed?</p>
        <select
          v-model="team.jobRefreshReviewStrategy"
          class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        >
          <option value="manual_approve_ai">Manual Review</option>
          <option value="auto_approve_ai">Automatically Approve</option>
        </select>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal.vue';
import ToggleInput from '../../../shared/ToggleInput.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    Modal,
    ToggleInput,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      loaded: false,
      team: {
        id: '',
        useAiForJobRefresh: false,
        jobRefreshReviewStrategy: 'manual_no_ai',
      },
    };
  },
  watch: {
    'team.useAiForJobRefresh'(newValue) {
      if (newValue === false) {
        this.team.jobRefreshReviewStrategy = 'manual_no_ai';
      } else {
        if (this.team.jobRefreshReviewStrategy === 'manual_no_ai') {
          this.team.jobRefreshReviewStrategy = 'manual_approve_ai';
        }
      }
    },
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    handleCancelSettings() {
      this.$emit('handleCancelSettings');
    },
    async getTeam() {
      try {
        const response = await fetch('/api/team');
        const data = await response.json();

        this.team.id = data.id;
        this.team.useAiForJobRefresh = data.record.job_refresh_review_strategy !== 'manual_no_ai';
        this.team.jobRefreshReviewStrategy = data.record.job_refresh_review_strategy;
        this.loaded = true;
      } catch (error) {
        toast.error('Error loading team', {
          action: { label: 'Dismiss' },
          description: 'An unexpected error occurred',
        });
      }
    },
    async updateTeam() {
      try {
        this.loadingSpinnerStore.showLocalLoadingSpinner();
        const response = await fetch('/api/team', {
          method: 'PUT',
          body: JSON.stringify({
            job_refresh_review_strategy: this.team.jobRefreshReviewStrategy,
          }),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
          },
        });

        const data = await response.json();
        this.loadingSpinnerStore.hideLocalLoadingSpinner();

        if (data.status !== 'error') {
          toast.success('Workflow updated', {
            action: { label: 'Dismiss' },
            description: 'Your workflow was successfully updated. Use the button below to dismiss this alert.',
          });
        } else {
          toast.error('Workflow update error', {
            action: { label: 'Dismiss' },
            description: data.message,
          });
        }

        if (data.status !== 'error') {
          this.$emit('handleSaveSettings');
        }
      } catch (error) {
        this.loadingSpinnerStore.hideLocalLoadingSpinner();
        toast.error('Workflow update error', {
          action: { label: 'Dismiss' },
          description: 'An unexpected error occurred',
        });
      }
    },
  },
};
</script>
